export const channel = {
  name: "Channel |||| Channels",
  fields: {
    name: "Name",
    type: "Type",
    isEnabled: "Enabled",
    config: "Configuration",
    connectionStatus: "Connection Status",
    createdAt: "Created at",
    updatedAt: "Updated at",
  },
  types: {
    WHATSAPP: "WhatsApp",
    TELEGRAM: "Telegram",
    EMAIL: "Email",
    SMS: "SMS",
    WEBCHAT: "Webchat",
    INSTAGRAM: "Instagram",
    FACEBOOK: "Facebook",
    INTERNAL: "Internal",
    ZAPY: "Zapy",
    whatsapp: "WhatsApp",
    telegram: "Telegram",
    email: "Email",
    sms: "SMS",
    webchat: "Webchat",
    instagram: "Instagram",
    facebook: "Facebook",
    internal: "Internal",
    zapy: "Zapy",
    unknown: "Unknown",
    whatsapp_official: "WhatsApp Official",
  },
  tabs: {
    details: "Channel Details",
    connections: "Channel Connections",
    whatsapp: "WhatsApp",
  },
  filters: {
    type: "Channel type",
    isEnabled: "Enabled",
  },
  comingSoon: "Coming soon",
  empty: {
    title: "No channels",
    subtitle: "There are no channels configured yet.",
  },
  create: {
    title: "Create Channel",
  },
  edit: {
    title: "Edit Channel",
  },
  wizard: {
    selectChannel: "Select a channel type",
    selectChannelDescription:
      "Choose the type of channel you want to create to start receiving messages",
    createChannel: "Create Channel",
    queueHelper:
      "Tickets from this channel will be routed to this queue",
    types: {
      zapy: {
        title: "Zapy (WhatsApp)",
        description:
          "Connect your phone's WhatsApp via Zapy to receive and reply to messages",
      },
      telegram: {
        title: "Telegram",
        description:
          "Create a Telegram bot to interact with customers on the platform",
      },
      email: {
        title: "Email",
        description:
          "Connect your email inbox to manage support emails as tickets",
      },
    },
    steps: {
      channelInfo: "Information",
      botSetup: "Bot Setup",
      provider: "Provider",
      serverConfig: "Configuration",
      smtpSetup: "SMTP Setup",
      imapSetup: "IMAP Setup",
      finish: "Complete",
    },
    errors: {
      nameRequired: "Channel name is required",
      emailRequired: "Email is required",
      invalidEmail: "Please enter a valid email address",
      botTokenRequired: "Bot token is required",
      smtpAddressRequired: "SMTP server address is required",
      smtpLoginRequired: "SMTP login is required",
      smtpPasswordRequired: "SMTP password is required",
      imapAddressRequired: "IMAP server address is required",
      imapLoginRequired: "IMAP login is required",
      imapPasswordRequired: "IMAP password is required",
      createFailed: "Failed to create channel",
      fillRequired: "Please fill in the required fields",
      queueRequired: "Queue is required",
    },
    success: {
      channelCreated: "Channel created successfully",
    },
    zapy: {
      title: "Create Zapy Channel",
      subtitle: "Connect your phone's WhatsApp via Zapy",
      instructions:
        "After creating the channel, you will be able to link your WhatsApp number by scanning a QR code on your phone.",
      namePlaceholder: "e.g., Support WhatsApp",
      nameHelper: "A name to identify this Zapy connection",
      successTitle: "Channel Created Successfully!",
      successMessage:
        "Your Zapy channel has been created. Now you need to link your WhatsApp number by scanning the QR code on your phone.",
      goToChannel: "Go to Channel & Connect",
    },
    telegram: {
      title: "Create Telegram Channel",
      subtitle: "Connect your Telegram bot",
      step1Description:
        "First, give your channel a name to identify it in the system.",
      namePlaceholder: "e.g., Support Bot",
      nameHelper: "A name to identify this Telegram bot",
      howToGetToken: "How to get a Bot Token:",
      step1_open: "Open Telegram and search for",
      step2_newbot:
        "Send /newbot and follow the instructions to create your bot",
      step3_copy: "Copy the token provided by BotFather",
      botToken: "Bot Token",
      tokenHelper: "The token you received from BotFather",
      successTitle: "Channel Created Successfully!",
      successMessage:
        "Your Telegram bot has been connected. You can now receive messages from your customers.",
      goToChannel: "Go to Channel",
    },
    email: {
      title: "Create Email Channel",
      subtitle: "Connect your email inbox",
      step1Description:
        "Enter the basic information for your email channel.",
      namePlaceholder: "e.g., Support Email",
      nameHelper: "A name to identify this email channel",
      emailAddress: "Email Address",
      replyToDomain: "Reply-To Domain",
      replyToDomainHelper:
        "Domain for reply-to addresses (optional)",
      selectProvider: "Select your email provider",
      selectProviderDescription:
        "Choose a provider to auto-fill server settings",
      providerGmail: "Gmail",
      providerGmailDesc:
        "Google accounts (Gmail, Google Workspace)",
      providerOutlook: "Outlook / Microsoft 365",
      providerOutlookDesc:
        "Microsoft 365, Outlook.com, Hotmail",
      providerOther: "Other provider",
      providerOtherDesc:
        "Manual IMAP and SMTP server configuration",
      inboundSection: "Inbound (IMAP)",
      outboundSection: "Outbound (SMTP)",
      serverConfigDescription:
        "Configure inbound and outbound mail servers. Settings have been pre-filled based on the selected provider.",
      serverConfigDescriptionManual:
        "Manually configure inbound and outbound mail servers.",
      smtpDescription:
        "SMTP settings are used to send emails. Configure your outgoing mail server.",
      enableSmtp: "Enable SMTP (Outbound)",
      smtpAddress: "SMTP Server",
      smtpPort: "Port",
      smtpLogin: "Username",
      smtpPassword: "Password",
      securitySettings: "Security",
      starttlsHelp: "Port 587: STARTTLS (upgrades to TLS)",
      sslHelp: "Port 465: SSL/TLS (encrypted from start)",
      smtpSelfSignedCert: "Accept self-signed certificates",
      smtpSelfSignedCertHelp:
        "Enable only if your mail server uses a self-signed or untrusted certificate.",
      imapDescription:
        "IMAP settings are used to receive emails. This is optional - you can also use email forwarding instead.",
      enableImap: "Enable IMAP (Inbound)",
      imapAddress: "IMAP Server",
      imapPort: "Port",
      imapLogin: "Username",
      imapPassword: "Password",
      imapSsl: "Enable SSL/TLS",
      usernameHelper: "Usually your full email address",
      passwordHelper:
        "For Gmail or Outlook, use an App Password",
      appPasswordTooltip:
        "App Passwords are special passwords generated in your email provider's security settings. They are required when two-factor authentication is enabled.",
      noProtocolWarning: "No email server configured",
      noProtocolWarningDetail:
        "Without IMAP, incoming emails will not be imported. Without SMTP, emails cannot be sent from the platform.",
      testConnection: "Test Connection",
      testingConnection: "Testing...",
      testConnectionSuccess:
        "Connection verified successfully!",
      testConnectionFailed:
        "Connection verification failed",
      testConnectionNote:
        "You can test again in the channel settings",
      smtpVerified: "SMTP verified",
      imapVerified: "IMAP verified",
      smtpNotVerified: "SMTP not verified",
      imapNotVerified: "IMAP not verified",
      configSummary: "Configuration summary",
      imapConfigured: "IMAP configured",
      smtpConfigured: "SMTP configured",
      notConfigured: "Not configured",
      successTitle: "Email Channel Created Successfully!",
      successMessage:
        "Your email channel has been configured. You can now receive and send emails through this channel.",
      goToChannel: "Go to Channel",
    },
  },
  connection: {
    connected: "Connected",
    disconnected: "Disconnected",
  },
  zapy: {
    title: "WhatsApp Connection",
    status: "Status",
    noConnection: "No connection",
    noConnections: "No WhatsApp connections configured",
    scanQRCode: "Scan QR Code",
    scanQRTitle: "Scan QR Code",
    scanQRInstructions:
      "Open WhatsApp on your phone, go to Settings > Linked Devices > Link a Device, and scan this QR code.",
    refreshQR: "Refresh QR",
    restart: "Restart",
    disconnect: "Disconnect",
    confirmRestart: "Restart Connection?",
    confirmLogout: "Disconnect WhatsApp?",
    restartWarning:
      "This will restart the WhatsApp connection. You may need to scan the QR code again.",
    logoutWarning:
      "This will disconnect your WhatsApp. You will need to scan the QR code again to reconnect.",
    profileName: "Profile",
    phoneNumber: "Phone",
    statuses: {
      connected: "Connected",
      disconnected: "Disconnected",
      pending_qr_code_scan: "Awaiting QR",
      connecting: "Connecting",
      error: "Error",
      not_found: "Not found",
      created: "Created",
    },
    notifications: {
      statusFetchFailed: "Failed to fetch status",
      qrFetchFailed: "Failed to fetch QR Code",
      restarted: "Connection restarted",
      restartFailed: "Failed to restart connection",
      disconnected: "WhatsApp disconnected",
      logoutFailed: "Failed to disconnect",
    },
  },
  telegram: {
    title: "Telegram Connection",
    status: "Status",
    noConnection: "No connection",
    noConnections: "No Telegram connections configured",
    connect: "Connect Bot",
    disconnect: "Disconnect",
    confirmDisconnect: "Disconnect Telegram Bot?",
    disconnectWarning:
      "This will disconnect the Telegram bot. New messages will not be received until reconnected.",
    botUsername: "Bot",
    webhookUrl: "Webhook URL",
    setupInstructions:
      "Click 'Connect Bot' to register the webhook and start receiving messages from Telegram.",
    statuses: {
      connected: "Connected",
      disconnected: "Disconnected",
    },
    notifications: {
      connected: "Telegram bot connected successfully",
      disconnected: "Telegram bot disconnected",
      setupFailed: "Failed to connect Telegram bot",
      disconnectFailed: "Failed to disconnect Telegram bot",
    },
    setup: {
      title: "Add Telegram Bot",
      instructions:
        "To connect a Telegram bot, you need to create a bot with @BotFather and copy the token.",
      step1: "Open Telegram and search for",
      step2:
        "Send /newbot and follow the instructions to create your bot",
      step3: "Copy the bot token and paste it below",
      connectionName: "Connection name",
      botToken: "Bot Token",
      tokenHelper:
        "The token is provided by @BotFather when you create the bot",
      addBot: "Add Bot",
      creating: "Creating...",
      connecting: "Connecting...",
    },
    errors: {
      tokenRequired: "Bot token is required",
      invalidToken:
        "Invalid token. The token should be in format 123456789:ABCdef...",
      createFailed:
        "Failed to create connection. Check if the token is correct.",
    },
    botInfo: {
      name: "Name",
      username: "Username",
      canJoinGroups: "Groups",
      canReadGroupMessages: "Read group messages",
      webhookError: "Webhook Error",
      webhookErrorDescription:
        "Telegram is trying to deliver messages, but the server returned an error: %{error}",
    },
    groupSetup: {
      title: "Group Configuration",
      description:
        "To use the bot in Telegram groups, follow the steps below in @BotFather.",
      allowGroupsTitle: "1. Allow the bot to join groups",
      allowGroups: {
        step1: "Open Telegram and go to @BotFather",
        step2:
          "Send /mybots → Select %{botName} → Bot Settings → Allow Groups → Turn ON",
        step3:
          "This allows the bot to be added to groups and supergroups",
      },
      privacyTitle: "2. Disable Privacy Mode",
      privacy: {
        step1: "Still in Bot Settings on @BotFather:",
        step2:
          "Group Privacy → Turn OFF (for %{botName})",
      },
      readdBot:
        "After changing these settings, remove and re-add the bot to the group to apply.",
      note: "With Privacy Mode enabled, the bot only receives commands (/), mentions (@bot), and replies to its own messages — regular messages from other members won't be received.",
      allConfigured:
        "Bot is properly configured to receive group messages.",
    },
  },
  email: {
    setup: {
      title: "Set Up Email Channel",
      description:
        "Configure an email channel to receive and send messages via email.",
      steps: {
        basicInfo: "Basic Information",
        complete: "Complete",
      },
      fields: {
        channelName: "Channel Name",
        email: "Email Address",
        replyToDomain: "Reply-To Domain",
      },
      helpers: {
        channelName:
          "A name to identify this channel (e.g., Support, Sales)",
        email:
          "The email address that will receive messages (e.g., support@company.com)",
        replyToDomain:
          "Domain used to generate reply addresses (e.g., tickets.company.com)",
      },
      validation: {
        nameRequired: "Channel name is required",
        emailRequired: "Email address is required",
        emailInvalid: "Invalid email address",
        domainRequired: "Reply-To domain is required",
      },
      info: {
        imapSmtpLater:
          "You can configure IMAP and SMTP later in the channel settings.",
      },
      createChannel: "Create Channel",
      error: "Failed to create email channel",
      success: {
        title: "Email Channel Created!",
        description:
          "Your email channel has been created successfully.",
        nextSteps:
          "Next step: Configure IMAP and SMTP options in channel settings to enable sending and receiving emails.",
      },
    },
    imap: {
      title: "IMAP Settings",
      subtitle:
        "Configure the IMAP server to receive emails directly.",
      note: "IMAP allows the system to fetch emails directly from your inbox.",
      toggle: "Enable IMAP",
      toggleHelp:
        "When enabled, the system will automatically fetch emails from the IMAP server.",
      address: "IMAP Server Address",
      port: "Port",
      login: "Login/Username",
      password: "Password",
      enableSsl: "Enable SSL/TLS",
      save: "Save IMAP Settings",
      saveSuccess: "IMAP settings saved successfully",
      saveError: "Failed to save IMAP settings",
      validation: {
        addressRequired: "Server address is required",
        portRequired: "Port is required",
        loginRequired: "Login is required",
        passwordRequired: "Password is required",
      },
    },
    smtp: {
      title: "SMTP Settings",
      subtitle:
        "Configure the SMTP server to send emails.",
      toggle: "Enable SMTP",
      toggleHelp:
        "When enabled, the system will use this server to send emails.",
      address: "SMTP Server Address",
      port: "Port",
      login: "Login/Username",
      password: "Password",
      domain: "Domain",
      domainHelp: "Domain used in the HELO/EHLO command",
      encryption: "Encryption",
      openSslVerifyMode: "OpenSSL Verify Mode",
      authMechanism: "Authentication Mechanism",
      save: "Save SMTP Settings",
      saveSuccess: "SMTP settings saved successfully",
      saveError: "Failed to save SMTP settings",
      validation: {
        addressRequired: "Server address is required",
        portRequired: "Port is required",
        loginRequired: "Login is required",
        passwordRequired: "Password is required",
        domainRequired: "Domain is required",
      },
    },
    config: {
      title: "Email Configuration",
      notFound: "Connection not found",
      tabs: {
        imap: "IMAP (Receiving)",
        smtp: "SMTP (Sending)",
      },
      imapStatus: "IMAP: %{status}",
      smtpStatus: "SMTP: %{status}",
      enabled: "Enabled",
      disabled: "Disabled",
      noConfigWarning:
        "Neither IMAP nor SMTP is configured. Configure at least one to use this email channel.",
    },
  },
  settings: {
    title: "Connection Settings",
    saveSuccess: "Settings saved successfully",
    saveError: "Failed to save settings",
    queueRequired: "Please select a queue before saving",
    ticketMode: "Ticket Mode",
    ticketModeHelp:
      "Configure how tickets are created for incoming messages on this connection.",
    ticketModes: {
      auto: "Automatic",
      autoHelp:
        "Automatically creates tickets for new conversations",
      manual: "Manual",
      manualHelp:
        "Agents manually create tickets when needed",
      off: "Disabled",
      offHelp: "Chat-only mode, no tickets created",
    },
    defaultQueue: "Default Queue",
    defaultQueueHelp:
      "Select the queue where tickets from this connection will be routed. If not selected, the system default queue will be used.",
    useDefaultQueue: "Use system default queue",
    groupMessages: "Group Messages",
    groupMessagesHelp:
      "Configure how WhatsApp group messages are handled.",
    ignoreGroupMessages: "Ignore group messages",
    notifyGroupMessages:
      "Receive group messages (without creating tickets)",
    ignoreGroupMessagesWarning:
      "All group messages will be ignored and will not appear in the system.",
  },
};

export const channelConnection = {
  name: "Channel Connection |||| Channel Connections",
  fields: {
    identifier: "Identifier",
    displayName: "Display Name",
    isActive: "Active",
  },
};
